import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./locals/en_lang";
import es from "./locals/es_lang";

Vue.use(VueI18n);

export default new VueI18n({
  locale: navigator.language.split("-")[0],
  messages: {
    en: {
      lang: en
    },
    es: {
      lang: es
    }
  }
});
